import { ComponentProps } from "react";
import AuthorDetails from "@routes/Author/components/AuthorDetails";
import { FeedAuthor } from "@routes/Author/utils/types";

import { PROFILE_URI_MAPPING } from "./constants";

/**
 * Helper function to get the alternative path for the profiles.
 * @param uri The uri of the profile.
 * @returns {string|undefined}
 */
export const getProfilesAlternativePath = (
  uri?: string
): string | undefined => {
  const profileMatch = PROFILE_URI_MAPPING.find(
    (profile) => profile.uri === uri
  );

  return profileMatch?.urlPath;
};

/**
 * Helper function to get the author details props.
 * @param profile The profile content.
 * @returns {ComponentProps<typeof AuthorDetails>}
 */
export const getAuthorDetailsProps = ({
  name,
  image,
  urlPath,
  email = "",
  description = "",
  designation = "",
  twitterHandle = "",
}: FeedAuthor): ComponentProps<typeof AuthorDetails> => {
  const authorDetailsProps: ComponentProps<typeof AuthorDetails> = {
    headshotImage: image,
    name,
    designation,
    email,
    twitterHandle,
    bio_raw: description,
    urlPath,
  };

  return JSON.parse(JSON.stringify(authorDetailsProps));
};
